import { ca } from '@cian/analytics';

export function trackOpenNoLinksPopup(opponentId?: number) {
  ca('eventSite', {
    action: 'Open_sopr',
    category: 'Chat',
    label: 'NoLinksPopup',
    name: 'oldevent',
    page: {
      extra: {
        opponent_id: opponentId,
      },
    },
  });
}
